export default __webpack_public_path__ + "static/media/kaser.3b82dfb6.png";